import type {TransportTrajectory} from "@/models/trajectory/trajectory";

export interface AssignmentRoutingModel {
    trajectories: TransportTrajectory[],
    totalDuration: number,
    totalDistance: number,
    isOptimizing: boolean
}

export const AssignmentRoutingModelDefaults = () : AssignmentRoutingModel => {
    return {
        trajectories: [],
        totalDuration: 0,
        totalDistance: 0,
        isOptimizing: false
    }
}

